<template>
    <div class="achievement col-lg-4 col-md-4 col-sm-6 col-xs-12" :class="{achieved : achievement.isAchieved}">
        <b-card show-header class="mb-4" show-footer>
            <h3 slot="header" v-if="achievement.shopName">{{ $t('ACHIEVEMENT_TITLE', { amount: achievement.branches, shop: $t(achievement.shopName)})}}</h3>
            <h3 slot="header" v-else>{{ achievement.name | translate }}</h3>
            <div class="center text-center">
                <div class="icon-wrap">
                    <div class="icon-overlay" v-if="achievement.type === 'balance'">
                        <div class="badge" v-if="achievement.iconOverlay !== null">{{ achievement.iconOverlay | NiceAmount }}</div>
                    </div>
                    <div class="icon-overlay" v-if="achievement.type !== 'balance'">
                        <div class="badge" v-if="achievement.iconOverlay !== null">{{ achievement.iconOverlay }}</div>
                    </div>
                    <i class="icon fa achievement-font-icon" :class="achievement.faClass"></i>
                </div>
            </div>
            <div slot="footer" class="achievement-status">
                <div class="achievement-achieved" v-if="achievement.isAchieved">
                    <span class="achievement-text">{{ 'ACHIEVEDATE' | translate}}</span>
                    <span class="achievement-date">{{ new Date(achievement.date).toLocaleString() }}</span>
                </div>
                <div class="achievement-achieved" v-if="!achievement.isAchieved">
                    <span class="achievement-text">{{ 'NOTACHIEVED' | translate }}</span>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import NiceAmount from '../filters/NiceAmount';
export default {
    name:     'achievement',
    props:    ['achievement'],
    data() {
        return {
            test: this.$getBalance()
        };
    },
    methods:  {
        ...mapActions([
            'incrementAmount'
        ]),
        tl(val) {
            return NiceAmount(val);
        }
    }
};
</script>

<style scoped lang="less">
.panel .icon i {
    display: flex;
    justify-content: center;
    align-items: center;
}
.icon img {
    max-width: 100%;
    max-height: 6.6vw;
}
.icon-wrap {
    position: relative;
    .icon-overlay {
        position: absolute;
        top: 0;
        opacity: .8;
        width: 100%;
    }
}
.achievement {
    opacity: .6;
    &.achieved {
        opacity: 1;
    }
}
</style>
